export default "__VITE_ASSET__97f2bcf5__"